import * as React from 'react';
import {useState} from 'react';
import {SocialSupportListData, Props} from './model';
import {TouchableOpacity, View} from 'react-native';
import {useStyles} from '../../hooks/styles';
import {DeviceSize} from '../../theme/helpers';
import {SupportTable} from './supportTable';
import {Accordion} from '../accordion';
import {Text} from '../text';

const ArbitraryNestedDataItem = ({
  item,
  level = 1,
  isLast,
}: {
  item: SocialSupportListData;
  level?: number;
  isLast: boolean;
}) => {
  const [isOpen, setIsOpenState] = useState(false);
  const styles = useStyles(({theme, mediaOnly}) => ({
    borderBottom: {
      borderBottomWidth: 1,
      borderBottomColor: theme.color.borderColor,
      borderStyle: 'solid',
    },
    container: {
      backgroundColor: theme.color.primaryNonGreyBackground,
    },
    title: {
      ...mediaOnly(
        DeviceSize.desktop,
        {...theme.fonts.h5Light, paddingVertical: 26},
        {...theme.fonts.bodySmallLight, paddingVertical: 13},
      ),
      paddingRight: 16,
    },
    tableWrapper: {
      paddingLeft: 16,
      paddingRight: 16,
      ...mediaOnly(DeviceSize.desktop, {paddingBottom: 26}, {paddingBottom: 13}),
    },
  }));
  return (
    <View style={[styles.container, isLast ? {} : styles.borderBottom]}>
      <TouchableOpacity
        testID={`social-support-list-change-state-id`}
        activeOpacity={1}
        style={[{paddingLeft: 16 * level}, isOpen && !item.table ? styles.borderBottom : {}]}
        onPress={() => setIsOpenState(!isOpen)}>
        <Text style={styles.title}>{item.title}</Text>
      </TouchableOpacity>
      {!item.title || isOpen ? (
        <View>
          {item.table ? (
            <View style={[styles.tableWrapper, {paddingLeft: 16 * (level + 1)}]}>
              <SupportTable {...item.table} />
            </View>
          ) : null}
          {item.children
            ? item.children.map((child, index) => (
                <ArbitraryNestedDataItem
                  key={index}
                  item={child}
                  level={level + 1}
                  isLast={index + 1 === item.children?.length}
                />
              ))
            : null}
        </View>
      ) : null}
    </View>
  );
};

const AccordionWrapper = ({data, index}: {data: SocialSupportListData; index: number}) => {
  const [expanded, setExpanded] = useState(false);
  const styles = useStyles(() => ({
    accordionContent: {
      paddingVertical: 0,
      paddingHorizontal: 0,
    },
  }));
  return (
    <Accordion
      index={index}
      expanded={expanded}
      onChange={setExpanded}
      title={data.title}
      contentCustomStyle={styles.accordionContent}>
      {data.children?.map((item, key) => (
        <ArbitraryNestedDataItem key={key} item={item} isLast={key + 1 === data.children?.length} />
      ))}
    </Accordion>
  );
};

export default ({data}: Props) => {
  return (
    <View>
      {data.map((item, key) => (
        <AccordionWrapper index={key} key={key} data={item} />
      ))}
    </View>
  );
};
